import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Bike } from 'lucide-react';
export function ProductReveal() {
  return <section className="py-16 px-4 bg-slate-950 text-center" data-id="element-237">
      <div className="max-w-3xl mx-auto" data-id="element-238">
        <FadeIn data-id="element-239">
          <div className="flex justify-center mb-6" data-id="element-240">
            <Bike className="w-12 h-12 text-amber-500" strokeWidth={2} data-id="element-241" />
          </div>

          <h2 className="text-4xl md:text-5xl font-serif font-bold text-white mb-4 tracking-tight" data-id="element-242">
            PROTORRENDA 4-12
          </h2>

          <p className="text-2xl md:text-3xl text-amber-500 italic mb-3" data-id="element-243">
            El Método de los 4 Pilares
          </p>

          <p className="text-lg md:text-xl text-slate-400 italic mb-12" data-id="element-244">
            Pack 6 Tomos + 2 Bonos
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-245">
          <div className="bg-slate-900 border border-amber-500/30 rounded-2xl p-8 md:p-10 max-w-2xl mx-auto shadow-lg" data-id="element-246">
            <p className="text-lg md:text-xl text-slate-300 mb-8 leading-relaxed" data-id="element-247">
              No es un plan genérico. No es teoría de manual europeo. No es
              normativa de potenciómetro.
            </p>
            <p className="text-xl md:text-2xl text-white font-bold leading-tight" data-id="element-248">
              Es tu protocolo de entrenamiento. Tu sistema. Tu transformación.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}